module.exports = __webpack_public_path__ + "static/media/liked.2cf72c04.svg";